"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgHealthierChoice = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m10.336 2.89-8 12a2 2 0 0 0 .77 2.899l8 4a2 2 0 0 0 1.789 0l8-4a2 2 0 0 0 .77-2.898l-8-12a2 2 0 0 0-3.329 0ZM18.56 13.84 20 16l-8 4-8-4 1.441-2.162 6.112 3.056.124.052a1 1 0 0 0 .77-.052l6.113-3.055Zm-1.118-1.678L16.06 10.09l-3.612 1.805a1 1 0 0 1-.771.052l-.124-.052-3.612-1.806-1.381 2.073 5.44 2.72 5.441-2.72ZM9.06 8.411 12 9.881l2.941-1.47L12.001 4 9.06 8.411Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgHealthierChoice);
//# sourceMappingURL=SvgHealthierChoice.js.map